import React, { Fragment } from 'react'
import TasksContainer from '@app/containers/students/Tasks'
import Tasks from '@app/components/students/Tasks'
import Logo from '@app/components/shared/Logo'
import { CompetitionPart } from '@app/components/shared/students/LandingPart'
import Platform from '@app/components/Landing/Platform'
import Timer from '@app/components/students/Timer'
import FinishNotice from './FinishNotice'
import classnames from 'classnames'

const TasksContent = (props) => {
  return (
    <Fragment>
      <div className="student-tasks-page__content-wrapper">
        <div className="student-tasks-page__tasks-wrapper">
          <Tasks {...props} />
        </div>
      </div>

      <div className="student-tasks-page__content-wrapper" style={{ margin: '16px 16px 0px 16px', alignSelf: 'center' }}>
        <FinishNotice {...props} />
      </div>
    </Fragment>
  )
}

const MainTasks = ({ global, student }) => {
  const classes = classnames(
    'page', 'student-tasks-page',
    'student-tasks-page--main'
  )

  return (
    <Fragment>
      <div className={classes}>
        <div className="student-tasks-page__inner">
          <div className="student-tasks-page__title">
            <div className="student-tasks-page__left">
              <div className="student-tasks-page__left-inner">
                Time’s Ticking! Tap on the tasks and solve&nbsp;them. Good luck!
              </div>
            </div>
            <div className="student-tasks-page__center">
              <Logo event={global.event} />
              <Platform theme="white" className="hide-mobile" />
            </div>
            <div className="student-tasks-page__right">
              <Timer student={student} />
            </div>
          </div>
          <TasksContainer
            student={student}
            tour="main"
            className="main"
            ChildComponent={TasksContent}
          />
        </div>
      </div>
      <CompetitionPart global={global} />
    </Fragment>
  )
}

export default MainTasks
